import React from 'react'
import './style.scss'
const Translate = require('react-redux-i18n').Translate
class AppFooter extends React.Component {
  render() {
    return (
      <div className="footer">
        <div className="footer__bottom">
          <div className="row">
            <div className="col-sm-6">
              <p>
                <strong>
                  <Translate value="application.titleAdmin" />
                </strong>
              </p>
            </div>
            <div className="col-sm-6">
              <div className="footer__copyright">
                <img
                  className="logoFooter"
                  src="resources/quqoImages/tlingLogo.png"
                  target="_blank"
                  rel="noopener noreferrer"
                  alt="Mediatec Software"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AppFooter



// WEBPACK FOOTER //
// ./src/components/LayoutComponents/Footer/index.js